import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { PaginationState } from 'app/shared/pagination/pagination.model';

export const renderSortingIcons = (
  columnName: string,
  pagination: PaginationState,
  sortByColumn: (event: React.MouseEvent<HTMLDivElement>) => void,
) => {
  return (
    <div id={columnName} className="table-sort" onClick={e => sortByColumn(e)}>
      {pagination?.column !== columnName ? (
        <FontAwesomeIcon icon={'sort'} className={'icon-table-header'} />
      ) : pagination?.direction === 'asc' ? (
        <FontAwesomeIcon icon={'sort-up'} className={'icon-table-header'} />
      ) : (
        <FontAwesomeIcon icon={'sort-down'} className={'icon-table-header'} />
      )}
    </div>
  );
};

export const onPageChangedUtil = (page: number, setPagination: Function, updateTableCallback: Function) => {
  setPagination(s => ({ ...s, page }));
  updateTableCallback(page, null, null, null);
};

export const onSizeChangedUtil = (size: number, pagination: PaginationState, setPagination: Function, updateTableCallback: Function) => {
  if (pagination.total < size * pagination.page) {
    let maxPage = Math.ceil(pagination.total / size);

    if (maxPage === 0) {
      maxPage = 1;
    }

    setPagination(s => ({ ...s, page: maxPage, size }));
    updateTableCallback(maxPage, size, null, null);
  } else {
    setPagination(s => ({ ...s, size }));
    updateTableCallback(null, size, null, null);
  }
};

export const sortByColumnUtil = (
  event: React.MouseEvent<HTMLDivElement>,
  pagination: PaginationState,
  setPagination: Function,
  updateTableCallback: Function,
) => {
  const column = event.currentTarget.id;

  let direction = 'asc';
  if (column === pagination.column && pagination.direction === 'asc') {
    direction = 'desc';
  }

  setPagination(s => ({ ...s, direction, column }));
  updateTableCallback(null, null, column, direction);
};

export const sortByColumnWithoutUpdateUtil = (
  event: React.MouseEvent<HTMLDivElement>,
  pagination: PaginationState,
  setPagination: Function,
) => {
  const column = event.currentTarget.id;

  let direction = 'asc';
  if (column === pagination.column && pagination.direction === 'asc') {
    direction = 'desc';
  }

  setPagination(s => ({ ...s, direction, column }));
};
